import { render, staticRenderFns } from "./UsersSelector.vue?vue&type=template&id=45c0917c&"
import script from "./UsersSelector.vue?vue&type=script&lang=js&"
export * from "./UsersSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports